var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 11.7227C11.1562 12.3817 11.6984 12.916 12.3671 12.916C13.0358 12.916 13.5779 12.3817 13.5779 11.7227C13.5779 11.0636 13.0358 10.5293 12.3671 10.5293C11.6984 10.5293 11.1562 11.0636 11.1562 11.7227Z",
    stroke: "#818183",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1592 5.99676C6.77793 5.69755 3.16844 5.05681 1.46948 4.5625V11.7715C1.46948 13.3582 1.46948 14.1515 1.96962 14.7986C2.46976 15.4456 3.15596 15.6284 4.52835 15.9938C6.74567 16.5843 9.07634 16.936 11.1647 17.1371C13.3291 17.3455 14.4113 17.4497 15.2054 16.7345C15.9995 16.0193 15.9995 14.8704 15.9995 12.5725V10.9705C15.9995 8.73904 15.9995 7.6233 15.348 6.93082C14.6965 6.23834 13.5174 6.15781 11.1592 5.99676Z",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2758 6.15428C13.5806 5.02197 13.8566 2.96263 13.0346 1.94008C12.5136 1.29197 11.7392 1.35424 10.98 1.42005C6.9892 1.76596 4.17 2.46865 2.59395 2.94604C1.91626 3.15132 1.46948 3.80355 1.46948 4.53167",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVallet);
export default __webpack_public_path__ + "static/media/vallet.93fd208dcb5cded3681324d32c46e871.svg";
export { ForwardRef as ReactComponent };